module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Ultralight.b383a1f.woff2";